import eclipse_interior_1_sm from '../../../assets/vehicles/eclipse/eclipse-interior-1-sm.jpg'
import eclipse_interior_1_lg from '../../../assets/vehicles/eclipse/eclipse-interior-1-lg.jpg'
import eclipse_interior_2_sm from '../../../assets/vehicles/eclipse/eclipse-interior-2-sm.jpg'
import eclipse_interior_2_lg from '../../../assets/vehicles/eclipse/eclipse-interior-2-lg.jpg'

import eclipse_exterior_virtual_tour from '../../../assets/vehicles/eclipse/eclipse-exterior-virtual-tour.jpg'
import eclipse_exterior_01_sm from '../../../assets/vehicles/eclipse/eclipse-exterior-01-sm.png'
import eclipse_exterior_01_lg from '../../../assets/vehicles/eclipse/eclipse-exterior-01-lg.png'
import eclipse_exterior_02_sm from '../../../assets/vehicles/eclipse/eclipse-exterior-02-sm.png'
import eclipse_exterior_02_lg from '../../../assets/vehicles/eclipse/eclipse-exterior-02-lg.png'
import eclipse_exterior_03_sm from '../../../assets/vehicles/eclipse/eclipse-exterior-03-sm.png'
import eclipse_exterior_03_lg from '../../../assets/vehicles/eclipse/eclipse-exterior-03-lg.png'
import eclipse_exterior_04_sm from '../../../assets/vehicles/eclipse/eclipse-exterior-04-sm.png'
import eclipse_exterior_04_lg from '../../../assets/vehicles/eclipse/eclipse-exterior-04-lg.png'
import eclipse_exterior_05_sm from '../../../assets/vehicles/eclipse/eclipse-exterior-05-sm.png'
import eclipse_exterior_05_lg from '../../../assets/vehicles/eclipse/eclipse-exterior-05-lg.png'
import eclipse_exterior_06_sm from '../../../assets/vehicles/eclipse/eclipse-exterior-06-sm.png'
import eclipse_exterior_06_lg from '../../../assets/vehicles/eclipse/eclipse-exterior-06-lg.png'
import eclipse_exterior_07_sm from '../../../assets/vehicles/eclipse/eclipse-exterior-07-sm.png'
import eclipse_exterior_07_lg from '../../../assets/vehicles/eclipse/eclipse-exterior-07-lg.png'
import eclipse_exterior_08_sm from '../../../assets/vehicles/eclipse/eclipse-exterior-08-sm.png'
import eclipse_exterior_08_lg from '../../../assets/vehicles/eclipse/eclipse-exterior-08-lg.png'
import eclipse_exterior_09_sm from '../../../assets/vehicles/eclipse/eclipse-exterior-09-sm.png'
import eclipse_exterior_09_lg from '../../../assets/vehicles/eclipse/eclipse-exterior-09-lg.png'
import eclipse_exterior_10_sm from '../../../assets/vehicles/eclipse/eclipse-exterior-10-sm.png'
import eclipse_exterior_10_lg from '../../../assets/vehicles/eclipse/eclipse-exterior-10-lg.png'
import eclipse_exterior_11_sm from '../../../assets/vehicles/eclipse/eclipse-exterior-11-sm.png'
import eclipse_exterior_11_lg from '../../../assets/vehicles/eclipse/eclipse-exterior-11-lg.png'
import eclipse_exterior_12_sm from '../../../assets/vehicles/eclipse/eclipse-exterior-12-sm.png'
import eclipse_exterior_12_lg from '../../../assets/vehicles/eclipse/eclipse-exterior-12-lg.png'
import eclipse_exterior_13_sm from '../../../assets/vehicles/eclipse/eclipse-exterior-13-sm.png'
import eclipse_exterior_13_lg from '../../../assets/vehicles/eclipse/eclipse-exterior-13-lg.png'
import eclipse_exterior_14_sm from '../../../assets/vehicles/eclipse/eclipse-exterior-14-sm.png'
import eclipse_exterior_14_lg from '../../../assets/vehicles/eclipse/eclipse-exterior-14-lg.png'
import eclipse_exterior_15_sm from '../../../assets/vehicles/eclipse/eclipse-exterior-15-sm.png'
import eclipse_exterior_15_lg from '../../../assets/vehicles/eclipse/eclipse-exterior-15-lg.png'
import eclipse_exterior_16_sm from '../../../assets/vehicles/eclipse/eclipse-exterior-16-sm.png'
import eclipse_exterior_16_lg from '../../../assets/vehicles/eclipse/eclipse-exterior-16-lg.png'

import eclipse_safety_airbags_1 from '../../../assets/vehicles/eclipse/eclipse-safety-airbags-1.svg'
import eclipse_safety_airbags_2 from '../../../assets/vehicles/eclipse/eclipse-safety-airbags-2.svg'
import eclipse_safety_airbags_3 from '../../../assets/vehicles/eclipse/eclipse-safety-airbags-3.svg'
import eclipse_safety_airbags_4 from '../../../assets/vehicles/eclipse/eclipse-safety-airbags-4.svg'

export const data = {
  virtualCardImage: {
    interior: eclipse_interior_1_sm,
    exterior: eclipse_exterior_virtual_tour,
  },
  interiorSlides: [
    {
      image: {
        sm: eclipse_interior_1_sm,
        lg: eclipse_interior_1_lg,
      },
      hotspots: [
        {
          x: 36,
          y: 22,
          action: '??',
          label: 'eclipse.interior.image-1.hotspot-1.label',
          message: 'eclipse.interior.image-1.hotspot-1.message',
          position: 'bottom',
        },
        {
          x: 56,
          y: 48,
          action: '??',
          label: 'eclipse.interior.image-1.hotspot-2.label',
          message: 'eclipse.interior.image-1.hotspot-2.message',
          position: 'left',
        },
        {
          x: 54,
          y: 63,
          action: '??',
          label: 'eclipse.interior.image-1.hotspot-3.label',
          message: 'eclipse.interior.image-1.hotspot-3.message',
          position: 'left',
        },
        {
          x: 33,
          y: 75,
          action: '??',
          label: 'eclipse.interior.image-1.hotspot-4.label',
          message: 'eclipse.interior.image-1.hotspot-4.message',
          position: 'bottom',
        },
        {
          x: 56,
          y: 30,
          action: '??',
          label: 'eclipse.interior.image-1.hotspot-5.label',
          message: 'eclipse.interior.image-1.hotspot-5.message',
          position: 'bottom',
        },
      ],
    },
    {
      image: {
        sm: eclipse_interior_2_sm,
        lg: eclipse_interior_2_lg,
      },
      hotspots: [
        {
          x: 15,
          y: 43,
          action: '??',
          label: 'eclipse.interior.image-2.hotspot-1.label',
          message: 'eclipse.interior.image-2.hotspot-1.message',
          position: 'top',
        },
        {
          x: 18,
          y: 76,
          action: '??',
          label: 'eclipse.interior.image-2.hotspot-2.label',
          message: 'eclipse.interior.image-2.hotspot-2.message',
          position: 'bottom',
        },
        {
          x: 57,
          y: 70,
          action: '??',
          label: 'eclipse.interior.image-2.hotspot-4.label',
          message: 'eclipse.interior.image-2.hotspot-4.message',
          position: 'top',
        },
      ],
    },
  ],
  exteriorSlides: [
    {
      image: {
        sm: eclipse_exterior_01_sm,
        lg: eclipse_exterior_01_lg,
      },
      hotspots: [
        {
          x: 33,
          y: 45,
          action: '??',
          label: 'eclipse.exterior.hotspot-1.label',
          message: 'eclipse.exterior.hotspot-1.message',
          position: 'bottom',
        },
        {
          x: 44,
          y: 63,
          action: '??',
          label: 'eclipse.exterior.hotspot-2.label',
          message: 'eclipse.exterior.hotspot-2.message',
          position: 'right',
        },
        {
          x: 70,
          y: 59,
          action: '??',
          label: 'eclipse.exterior.hotspot-3.label',
          message: 'eclipse.exterior.hotspot-3.message',
          position: 'top',
        },
      ],
    },
    {
      image: {
        sm: eclipse_exterior_02_sm,
        lg: eclipse_exterior_02_lg,
      },
      hotspots: [
        {
          x: 30,
          y: 45,
          action: '??',
          label: 'eclipse.exterior.hotspot-1.label',
          message: 'eclipse.exterior.hotspot-1.message',
          position: 'bottom',
        },
        {
          x: 35,
          y: 62,
          action: '??',
          label: 'eclipse.exterior.hotspot-2.label',
          message: 'eclipse.exterior.hotspot-2.message',
          position: 'right',
        },
        {
          x: 71,
          y: 59,
          action: '??',
          label: 'eclipse.exterior.hotspot-3.label',
          message: 'eclipse.exterior.hotspot-3.message',
          position: 'top',
        },
      ],
    },
    {
      image: {
        sm: eclipse_exterior_03_sm,
        lg: eclipse_exterior_03_lg,
      },
      hotspots: [
        {
          x: 30,
          y: 46,
          action: '??',
          label: 'eclipse.exterior.hotspot-1.label',
          message: 'eclipse.exterior.hotspot-1.message',
          position: 'bottom',
        },
        {
          x: 32,
          y: 63,
          action: '??',
          label: 'eclipse.exterior.hotspot-2.label',
          message: 'eclipse.exterior.hotspot-2.message',
          position: 'top',
        },
        {
          x: 70,
          y: 60,
          action: '??',
          label: 'eclipse.exterior.hotspot-3.label',
          message: 'eclipse.exterior.hotspot-3.message',
          position: 'top',
        },
      ],
    },
    {
      image: {
        sm: eclipse_exterior_04_sm,
        lg: eclipse_exterior_04_lg,
      },
      hotspots: [
        {
          x: 31,
          y: 45,
          action: '??',
          label: 'eclipse.exterior.hotspot-1.label',
          message: 'eclipse.exterior.hotspot-1.message',
          position: 'bottom',
        },
        {
          x: 29,
          y: 61,
          action: '??',
          label: 'eclipse.exterior.hotspot-2.label',
          message: 'eclipse.exterior.hotspot-2.message',
          position: 'top',
        },
        {
          x: 64,
          y: 62,
          action: '??',
          label: 'eclipse.exterior.hotspot-3.label',
          message: 'eclipse.exterior.hotspot-3.message',
          position: 'top',
        },
        {
          x: 63,
          y: 39,
          action: '??',
          label: 'eclipse.exterior.hotspot-4.label',
          message: 'eclipse.exterior.hotspot-4.message',
          position: 'bottom',
        },
      ],
    },
    {
      image: {
        sm: eclipse_exterior_05_sm,
        lg: eclipse_exterior_05_lg,
      },
      hotspots: [
        {
          x: 36,
          y: 60,
          action: '??',
          label: 'eclipse.exterior.hotspot-2.label',
          message: 'eclipse.exterior.hotspot-2.message',
          position: 'top',
        },
        {
          x: 56,
          y: 58,
          action: '??',
          label: 'eclipse.exterior.hotspot-3.label',
          message: 'eclipse.exterior.hotspot-3.message',
          position: 'top',
        },
        {
          x: 56,
          y: 39,
          action: '??',
          label: 'eclipse.exterior.hotspot-4.label',
          message: 'eclipse.exterior.hotspot-4.message',
          position: 'bottom',
        },
      ],
    },
    {
      image: {
        sm: eclipse_exterior_06_sm,
        lg: eclipse_exterior_06_lg,
      },
      hotspots: [
        {
          x: 37,
          y: 60,
          action: '??',
          label: 'eclipse.exterior.hotspot-3.label',
          message: 'eclipse.exterior.hotspot-3.message',
          position: 'top',
        },
        {
          x: 48,
          y: 39,
          action: '??',
          label: 'eclipse.exterior.hotspot-4.label',
          message: 'eclipse.exterior.hotspot-4.message',
          position: 'bottom',
        },
      ],
    },
    {
      image: {
        sm: eclipse_exterior_07_sm,
        lg: eclipse_exterior_07_lg,
      },
      hotspots: [
        {
          x: 39,
          y: 64,
          action: '??',
          label: 'eclipse.exterior.hotspot-3.label',
          message: 'eclipse.exterior.hotspot-3.message',
          position: 'top',
        },
        {
          x: 42,
          y: 40,
          action: '??',
          label: 'eclipse.exterior.hotspot-4.label',
          message: 'eclipse.exterior.hotspot-4.message',
          position: 'bottom',
        },
      ],
    },
    {
      image: {
        sm: eclipse_exterior_08_sm,
        lg: eclipse_exterior_08_lg,
      },
      hotspots: [
        {
          x: 62,
          y: 60,
          action: '??',
          label: 'eclipse.exterior.hotspot-3.label',
          message: 'eclipse.exterior.hotspot-3.message',
          position: 'top',
        },
        {
          x: 64,
          y: 51,
          action: '??',
          label: 'eclipse.exterior.hotspot-5.label',
          message: 'eclipse.exterior.hotspot-5.message',
          position: 'bottom',
        },
        {
          x: 38,
          y: 40,
          action: '??',
          label: 'eclipse.exterior.hotspot-4.label',
          message: 'eclipse.exterior.hotspot-4.message',
          position: 'bottom',
        },
      ],
    },
    {
      image: {
        sm: eclipse_exterior_09_sm,
        lg: eclipse_exterior_09_lg,
      },
      hotspots: [
        {
          x: 64,
          y: 61,
          action: '??',
          label: 'eclipse.exterior.hotspot-3.label',
          message: 'eclipse.exterior.hotspot-3.message',
          position: 'top',
        },
        {
          x: 35,
          y: 39,
          action: '??',
          label: 'eclipse.exterior.hotspot-4.label',
          message: 'eclipse.exterior.hotspot-4.message',
          position: 'bottom',
        },
        {
          x: 67,
          y: 51,
          action: '??',
          label: 'eclipse.exterior.hotspot-5.label',
          message: 'eclipse.exterior.hotspot-5.message',
          position: 'bottom',
        },
      ],
    },
    {
      image: {
        sm: eclipse_exterior_10_sm,
        lg: eclipse_exterior_10_lg,
      },
      hotspots: [
        {
          x: 68,
          y: 46,
          action: '??',
          label: 'eclipse.exterior.hotspot-1.label',
          message: 'eclipse.exterior.hotspot-1.message',
          position: 'bottom',
        },
        {
          x: 63,
          y: 62,
          action: '??',
          label: 'eclipse.exterior.hotspot-2.label',
          message: 'eclipse.exterior.hotspot-2.message',
          position: 'top',
        },
        {
          x: 35,
          y: 63,
          action: '??',
          label: 'eclipse.exterior.hotspot-3.label',
          message: 'eclipse.exterior.hotspot-3.message',
          position: 'top',
        },
        {
          x: 32,
          y: 40,
          action: '??',
          label: 'eclipse.exterior.hotspot-4.label',
          message: 'eclipse.exterior.hotspot-4.message',
          position: 'bottom',
        },
        {
          x: 67,
          y: 51,
          action: '??',
          label: 'eclipse.exterior.hotspot-5.label',
          message: 'eclipse.exterior.hotspot-5.message',
          position: 'left',
        },
      ],
    },
    {
      image: {
        sm: eclipse_exterior_11_sm,
        lg: eclipse_exterior_11_lg,
      },
      hotspots: [
        {
          x: 65,
          y: 46,
          action: '??',
          label: 'eclipse.exterior.hotspot-1.label',
          message: 'eclipse.exterior.hotspot-1.message',
          position: 'bottom',
        },
        {
          x: 69,
          y: 62,
          action: '??',
          label: 'eclipse.exterior.hotspot-2.label',
          message: 'eclipse.exterior.hotspot-2.message',
          position: 'top',
        },
        {
          x: 30,
          y: 63,
          action: '??',
          label: 'eclipse.exterior.hotspot-3.label',
          message: 'eclipse.exterior.hotspot-3.message',
          position: 'top',
        },
        {
          x: 31,
          y: 41,
          action: '??',
          label: 'eclipse.exterior.hotspot-4.label',
          message: 'eclipse.exterior.hotspot-4.message',
          position: 'bottom',
        },
        {
          x: 64,
          y: 51,
          action: '??',
          label: 'eclipse.exterior.hotspot-5.label',
          message: 'eclipse.exterior.hotspot-5.message',
          position: 'left',
        },
      ],
    },
    {
      image: {
        sm: eclipse_exterior_12_sm,
        lg: eclipse_exterior_12_lg,
      },
      hotspots: [
        {
          x: 66,
          y: 46,
          action: '??',
          label: 'eclipse.exterior.hotspot-1.label',
          message: 'eclipse.exterior.hotspot-1.message',
          position: 'bottom',
        },
        {
          x: 64,
          y: 64,
          action: '??',
          label: 'eclipse.exterior.hotspot-2.label',
          message: 'eclipse.exterior.hotspot-2.message',
          position: 'top',
        },
        {
          x: 28,
          y: 62,
          action: '??',
          label: 'eclipse.exterior.hotspot-3.label',
          message: 'eclipse.exterior.hotspot-3.message',
          position: 'top',
        },
        {
          x: 60,
          y: 53,
          action: '??',
          label: 'eclipse.exterior.hotspot-5.label',
          message: 'eclipse.exterior.hotspot-5.message',
          position: 'left',
        },
      ],
    },
    {
      image: {
        sm: eclipse_exterior_13_sm,
        lg: eclipse_exterior_13_lg,
      },
      hotspots: [
        {
          x: 65,
          y: 46,
          action: '??',
          label: 'eclipse.exterior.hotspot-1.label',
          message: 'eclipse.exterior.hotspot-1.message',
          position: 'bottom',
        },
        {
          x: 56,
          y: 63,
          action: '??',
          label: 'eclipse.exterior.hotspot-2.label',
          message: 'eclipse.exterior.hotspot-2.message',
          position: 'top',
        },
        {
          x: 30,
          y: 61,
          action: '??',
          label: 'eclipse.exterior.hotspot-3.label',
          message: 'eclipse.exterior.hotspot-3.message',
          position: 'top',
        },
        {
          x: 54,
          y: 53,
          action: '??',
          label: 'eclipse.exterior.hotspot-5.label',
          message: 'eclipse.exterior.hotspot-5.message',
          position: 'left',
        },
      ],
    },
    {
      image: {
        sm: eclipse_exterior_14_sm,
        lg: eclipse_exterior_14_lg,
      },
      hotspots: [
        {
          x: 60,
          y: 45,
          action: '??',
          label: 'eclipse.exterior.hotspot-1.label',
          message: 'eclipse.exterior.hotspot-1.message',
          position: 'bottom',
        },
        {
          x: 65,
          y: 63,
          action: '??',
          label: 'eclipse.exterior.hotspot-2.label',
          message: 'eclipse.exterior.hotspot-2.message',
          position: 'top',
        },
        {
          x: 33,
          y: 60,
          action: '??',
          label: 'eclipse.exterior.hotspot-3.label',
          message: 'eclipse.exterior.hotspot-3.message',
          position: 'top',
        },
        {
          x: 44,
          y: 53,
          action: '??',
          label: 'eclipse.exterior.hotspot-5.label',
          message: 'eclipse.exterior.hotspot-5.message',
          position: 'right',
        },
      ],
    },
    {
      image: {
        sm: eclipse_exterior_15_sm,
        lg: eclipse_exterior_15_lg,
      },
      hotspots: [
        {
          x: 49.5,
          y: 48,
          action: '??',
          label: 'eclipse.exterior.hotspot-1.label',
          message: 'eclipse.exterior.hotspot-1.message',
          position: 'bottom',
        },
        {
          x: 60,
          y: 64,
          action: '??',
          label: 'eclipse.exterior.hotspot-2.label',
          message: 'eclipse.exterior.hotspot-2.message',
          position: 'top',
        },
        {
          x: 39,
          y: 64,
          action: '??',
          label: 'eclipse.exterior.hotspot-3.label',
          message: 'eclipse.exterior.hotspot-3.message',
          position: 'top',
        },
      ],
    },
    {
      image: {
        sm: eclipse_exterior_16_sm,
        lg: eclipse_exterior_16_lg,
      },
      hotspots: [
        {
          x: 43,
          y: 46,
          action: '??',
          label: 'eclipse.exterior.hotspot-1.label',
          message: 'eclipse.exterior.hotspot-1.message',
          position: 'bottom',
        },
        {
          x: 34,
          y: 64,
          action: '??',
          label: 'eclipse.exterior.hotspot-2.label',
          message: 'eclipse.exterior.hotspot-2.message',
          position: 'top',
        },
        {
          x: 66,
          y: 61,
          action: '??',
          label: 'eclipse.exterior.hotspot-3.label',
          message: 'eclipse.exterior.hotspot-3.message',
          position: 'top',
        },
      ],
    },
  ],
  safetyTabs: [
    {
      label: 'eclipse.blueprint.safety.tab-1',
      image: eclipse_safety_airbags_1,
      dots: [
        {
          top: -5,
          left: 45,
          label: 'eclipse.blueprint.safety.hotspot-1.label',
          message: 'eclipse.blueprint.safety.hotspot-1.message',
          position: 'bottom',
        },
      ],
    },
    {
      label: 'eclipse.blueprint.safety.tab-2',
      image: eclipse_safety_airbags_2,
      dots: [
        {
          top: 52,
          left: 25,
          label: 'eclipse.blueprint.safety.hotspot-2.label',
          message: 'eclipse.blueprint.safety.hotspot-2.message',
          position: 'bottom',
        },
      ],
    },
    {
      label: 'eclipse.blueprint.safety.tab-3',
      image: eclipse_safety_airbags_3,
      dots: [
        {
          top: 7,
          left: 43,
          label: 'eclipse.blueprint.safety.hotspot-3.label',
          message: 'eclipse.blueprint.safety.hotspot-3.message',
          position: 'bottom',
        },
      ],
    },
    {
      label: 'eclipse.blueprint.safety.tab-4',
      image: eclipse_safety_airbags_4,
      dots: [
        {
          top: 16,
          left: 3,
          label: 'eclipse.blueprint.safety.hotspot-4.label',
          message: 'eclipse.blueprint.safety.hotspot-4.message',
          position: 'bottom',
        },
      ],
    },
  ],
}
